export const ADVANCED_SEARCH_PATH = 'advanced-search';
export const ADVANCED_SEARCH_FEATURE_TOGGLE = 'advanced-search-ISD-19913';
